import { Stimulus, Controller } from "#/application/js/stimulus"

import "tempusdominus-core"
import "tempusdominus-bootstrap-4"
import "tempusdominus-bootstrap-4/build/css/tempusdominus-bootstrap-4.css"

$.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
  icons: {
    up: "fas fa-arrow-up",
    down: "fas fa-arrow-down",
    previous: "fas fa-chevron-left",
    next: "fas fa-chevron-right"
  }
})

const startPicker = 'div[data-datepicker-target="start"]'
const endPicker   = 'div[data-datepicker-target="end"]'
const repeatPicker = 'div[data-datepicker-target="repeat"]'

const getDate = el => $(el).datetimepicker("date")
const nearestHalfHour = () => {
  let time = moment()
  if (time.minutes() < 30) {
    time.minutes(30).seconds(0)
  } else {
    time.add(1, "hours").minutes(0).seconds(0)
  }

  return time
}

Stimulus.register("datepicker", class extends Controller {
  static targets = ["start", "end", "repeat"]

  startTargetConnected(el) {
    this.initDatepicker(el)

    let startAt = document.querySelector("#request_start_at").value
    if (startAt == "") startAt = nearestHalfHour()

    $(el).datetimepicker("date", startAt)
    $(el).trigger("change.datetimepicker")
  }

  endTargetConnected(el) {
    this.initDatepicker(el)

    let minDate = nearestHalfHour().add(30, "minutes")
    const startAt = document.querySelector("#request_start_at").value
    if (startAt != "") minDate = moment(startAt).add(30, "minutes")
    $(el).datetimepicker("minDate", minDate)

    const endAt = document.querySelector("#request_end_at").value
    if (endAt != "") {
      $(el).datetimepicker("date", endAt)
    } else {
      $(el).datetimepicker("date", minDate)
    }

    if ($(endPicker).datetimepicker("date").isBefore(minDate))
      $(endPicker).datetimepicker("date", minDate)

    $(el).trigger("change.datetimepicker")
  }

  repeatTargetConnected(el) {
    $(el).datetimepicker({
      inline: true,
      format: "YYYY-MM-DD"
    })

    const repeatUntil = document.querySelector("#request_repeat_until").value
    if (repeatUntil != "")
      $(el).datetimepicker("date", repeatUntil)
  }

  initDatepicker(el) {
    const allDay = $("#request_all_day").is(":checked")

    $(el).datetimepicker({
      stepping: 30,
      sideBySide: true,
      inline: true,
      minDate: moment().startOf(allDay ? "day" : "hour"),
      format: (allDay ? "YYYY-MM-DD" : "Y-MM-DD[T]HH:mmZ")
    })
  }
})

$(document).on("change", "#request_all_day", function() {
  const allDay = document.querySelector("#request_all_day").checked

  $(`${startPicker}, ${endPicker}`).each(function() {
    $(this).datetimepicker("options", {
      minDate: moment().startOf(allDay ? "day" : "hour"),
      format: (allDay ? "YYYY-MM-DD" : "Y-MM-DD[T]HH:mmZ")
    })
  })
})

$(document).on("change.datetimepicker", startPicker, function() {
  // Event date is sometimes wrong, have to get directly from datetimepicker
  // But datetimepicker events can be fired before the picker is ready so check for null
  const startDate = getDate(this)
  if (!startDate) return

  $("#request_start_at").val(startDate.format()).trigger("change")
  const endDate = document.querySelector("#request_all_day").checked ? startDate : startDate.clone().add(30, "minutes")

  if ($(endPicker).data("datetimepicker")) {
    $(endPicker).datetimepicker("minDate", endDate)
    if ($(endPicker).datetimepicker("date").isBefore(endDate))
      $(endPicker).datetimepicker("date", endDate)
  }
})

$(document).on("change.datetimepicker", endPicker, function() {
  const endDate = getDate(this)
  if (!endDate) return
  $("#request_end_at").val(endDate.format()).trigger("change")
})

$(document).on("change.datetimepicker", repeatPicker, function() {
  const repeatDate = getDate(this)
  if (!repeatDate) return
  $("#request_repeat_until").val(repeatDate.format("YYYY-MM-DD")).trigger("change")
})
